import React, { useState } from "react";
import { Fab, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip, Zoom } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import { SUPPORT } from "../theme";

export default function SupportFab() {
  const [anchor, setAnchor] = useState(null);
  return (
    <>
      <Tooltip title="Falar com o suporte" placement="left" TransitionComponent={Zoom}>
        <Fab
          color="secondary"
          aria-label="suporte"
          onClick={(e) => setAnchor(e.currentTarget)}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1200,
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          }}
        >
          <SupportAgentIcon />
        </Fab>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <MenuItem
          component="a"
          href={`https://wa.me/${SUPPORT.whatsapp}?text=${encodeURIComponent("Olá, preciso de suporte com o portal do cliente.")}`}
          target="_blank"
          rel="noopener"
          onClick={() => setAnchor(null)}
        >
          <ListItemIcon><WhatsAppIcon sx={{ color: "#25D366" }} /></ListItemIcon>
          <ListItemText primary="WhatsApp" secondary={SUPPORT.whatsappDisplay} />
        </MenuItem>
        <MenuItem
          component="a"
          href={`mailto:${SUPPORT.email}?subject=${encodeURIComponent("Suporte Portal do Cliente")}`}
          onClick={() => setAnchor(null)}
        >
          <ListItemIcon><EmailIcon color="primary" /></ListItemIcon>
          <ListItemText primary="E-mail" secondary={SUPPORT.email} />
        </MenuItem>
      </Menu>
    </>
  );
}
